'use client'

import HomepageCarousel from '../../../widgets/HomepageCarousel/index.js'
import LoaderPage from '@/shared/ui/LoaderPage/index.js'
import QuestionAnswerBlock from '../../../entities/QuestionAnswerBlock/index.js'
import { Container } from 'react-bootstrap'
import { NewsList } from '../../../entities/NewsList/ui/NewsList.jsx'
import { useEffect, useState } from 'react'
import { useAboutTextMutation } from '@/shared/api-rtk/index.js'
import { Helmet } from 'react-helmet'
import Latest from '@/widgets/Latest'
import dynamic from 'next/dynamic'

const VebinarSlider = dynamic(() => import('@/widgets/VebinarsSlider'), {
    ssr: false, // Отключаем SSR для этого компонента
})

const ReviewSlider = dynamic(() => import('@/widgets/ReviewsSlider'), {
    ssr: false, // Отключаем SSR для этого компонента
})

export function ClientHomePage({ children }) {
    const [allMediaLoaded, setAllMediaLoaded] = useState(false)
    const [mountedComponents, setMountedComponents] = useState(0)

    // Функция для отслеживания загрузки изображений
    function waitForImagesToLoad(onComplete) {
        const images = Array.from(document.images)
        if (images.length === 0) {
            onComplete() // Нет изображений — завершаем сразу
            return
        }

        let loadedCount = 0
        const checkAllLoaded = () => {
            loadedCount += 1
            if (loadedCount === images.length) {
                onComplete() // Все изображения загружены
            }
        }

        images.forEach((img, idx) => {
            if (img.complete) {
                checkAllLoaded()
            } else {
                img.addEventListener('load', checkAllLoaded, { once: true })
                img.addEventListener('error', checkAllLoaded, { once: true })
            }
        })

        // Очистка слушателей при размонтировании
        return () => {
            images.forEach((img) => {
                img.removeEventListener('load', checkAllLoaded)
                img.removeEventListener('error', checkAllLoaded)
            })
        }
    }

    // Сброс состояния при каждом рендере
    useEffect(() => {
        setAllMediaLoaded(false)
        setMountedComponents(1)
    }, [])

    // Отслеживание завершения монтирования всех компонентов
    useEffect(() => {
        if (mountedComponents >= 4) {
            const cleanup = waitForImagesToLoad(() => setAllMediaLoaded(true))
            return cleanup // Очистка слушателей при размонтировании
        }
    }, [mountedComponents])

    // Обработчик монтирования дочерних компонентов
    const handleMount = () => {
        setMountedComponents((prev) => prev + 1)
    }

    return (
        <Container className={'HomePage'}>
            <LoaderPage loading={!allMediaLoaded} />
            <main className={'main-container'}>
                <div
                    className={`news-container animate__animated animate__slideInLeft`}
                >
                    <QuestionAnswerBlock onMount={handleMount} />
                    <NewsList onMount={handleMount} />
                </div>
                <div
                    className={`goods-container animate__animated animate__slideInRight`}
                >
                    <HomepageCarousel onMount={handleMount} />
                    {children}
                    <Latest onMount={handleMount} />
                </div>
            </main>
            <VebinarSlider />
            <ReviewSlider />
        </Container>
    )
}
